module.exports = __webpack_public_path__ + "static/media/appdev.fed27146.webp";